import {
  API_NOTIFICATION,
  API_NOTIFICATION_BY_ID,
  API_NOTIFICATION_READ,
  API_NOTIFICATION_TOAST,
  API_NOTIFICATION_UNREAD_COUNT,
} from 'config'
import Api from 'services/api'

export type NotificationLevel = 'info' | 'success' | 'warning' | 'error'

export type NotificationType =
  | 'task'
  | 'loan'
  | 'message'
  | 'payment'
  | 'condition'
  | 'document'
  | 'note'
  | 'servicing'
  | 'system'

export interface INotification {
  id: number
  type: NotificationType
  level: NotificationLevel
  source: 'system' | 'toast'
  title: string
  message: string
  link: string
  loanNumber: number
  createdBy: string
  meta: Record<string, any>
  isRead: boolean
  createdAt: string
}

export interface INotificationPage {
  data: INotification[]
  total: number
  unread: number
}

export const getNotifications = (filters: Record<string, any> = {}): Promise<INotificationPage> => {
  return Api.get(API_NOTIFICATION, filters)
}

export const getNotificationUnreadCount = (): Promise<{ unread: number }> => {
  return Api.get(API_NOTIFICATION_UNREAD_COUNT)
}

/** Logs a toast that was just shown, so it survives in the bell panel after it fades. */
export const logNotificationToast = (data: Record<string, any>) => {
  return Api.post(API_NOTIFICATION_TOAST, data)
}

export const markNotificationsRead = (ids: number[]) => {
  return Api.post(API_NOTIFICATION_READ, { ids })
}

export const markAllNotificationsRead = () => {
  return Api.post(API_NOTIFICATION_READ, { all: true })
}

/** Deletes everything already read, leaving the unread rows. */
export const clearReadNotifications = () => {
  return Api.delete(API_NOTIFICATION_READ)
}

export const deleteNotification = (id: number) => {
  return Api.delete(API_NOTIFICATION_BY_ID, {}, { id })
}
